/**
 * Removes characters not allowed in label titles (matches API normalization intent).
 * Allows unicode letters, numbers, spaces, hyphen, underscore.
 */
export const labelDisallowedCharsPattern = /[^\p{L}\p{N}\s_-]/gu;

/**
 * Normalizes free-text input into a label title: trim, lowercase, collapse spaces,
 * strip disallowed characters.
 *
 * @param {string | undefined | null} label
 * @returns {string}
 */
export const sanitizeLabel = (label = '') => {
  if (!label) return '';

  return label
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(labelDisallowedCharsPattern, '');
};
